import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers, URLSearchParams, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';
import { map, filter, catchError, mergeMap } from 'rxjs/operators';
import { documentMaster } from '../../Models/DocumentMasterModel'
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class AdmindocumentMasterServices {

  apiURL: string = "";

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    if (sessionStorage.getItem("BaseURL") != null && sessionStorage.getItem("BaseURL") != "") {
      this.apiURL = sessionStorage.getItem("BaseURL") || '';
      this.apiURL = this.apiURL + 'api/DocumentMasterAdmin';
    }
  }

  GetDocumentMasterFilterByPage(TokenKey: string, PageNumber: string, PageSize: string, WhereCondition: string, OrderBy: string): Observable<documentMaster[]> {    
    let fullAPIPath = this.apiURL + '/GetDocumentMasterFilterByPage/' + PageNumber + '/' + PageSize + '/' + WhereCondition + '/' + OrderBy;    
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this.http.get<documentMaster[]>(fullAPIPath, httpOptions)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: Response | any) {
    console.error(error.message || error);
    return Observable.throw(error.status)
  }

}
